import React from 'react'

import SummaryRevenueRow from './summary-revenue-row'

export default ({ data, reportType, groupBy }) => {
    return <SummaryRevenueRow groupBy={groupBy} property={data} />
}
